module.exports = __webpack_public_path__ + "static/media/tree_1.7f83358f.svg";